module.exports = __webpack_public_path__ + "static/me-97bb82f7669fe6800858553aa4f69ce8.jpg";